module.exports = __webpack_public_path__ + "static/media/symbol.c4f3402a.svg";